import axios from 'axios';

let newAxios; // this will hold our configured instance

export async function createAxiosInstance() {
  const response = await fetch('/config.json');
  const configData = await response.json();

  newAxios = axios.create({
    baseURL: configData.apiBaseUrl,
    headers: {
      //"Content-Type": "application/json",
      //"Content-Type": "multipart/form-data"
    }
  });

  newAxios.interceptors.request.use((config) => {
    const token = localStorage.getItem("wertyuiojhdfghhdrtfyguh");
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  });

  return newAxios;
}

export function getAxiosInstance() {
  if (!newAxios) {
    throw new Error('Axios instance not initialized. Call createAxiosInstance() first.');
  }
  return newAxios;
}
